import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { adminService } from '@/api/services/adminService';

// Define the shape of each router link item
interface RouterLink {
  functionalId: string;
  routerLink: string;
  assign: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
  view: boolean;
  print: boolean;
  approval: boolean;
}

interface RouterState {
  routerLinks: RouterLink[];
  loading: boolean;
  error: string | null;
}

const initialState: RouterState = {
  routerLinks: [],
  loading: false,
  error: null,
};

export const fetchRouterLinks = createAsyncThunk(
  'router/fetchRouterLinks',
  async (roles: string[], { rejectWithValue }) => {
    try {
      const response = await adminService.routerById({ roleIds: roles });
      // Safely access routerLinks from response
      return response.data?.routerLinks as RouterLink[];
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Something went wrong');
    }
  }
);

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    resetRouterState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRouterLinks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRouterLinks.fulfilled, (state, action: PayloadAction<RouterLink[]>) => {
        state.loading = false;
        state.routerLinks = action.payload;
      })
      .addCase(fetchRouterLinks.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetRouterState } = routerSlice.actions;

export default routerSlice.reducer;
